export default "__VITE_ASSET__CXFqbmGp__"